export default __webpack_public_path__ + "static/APP_3_3_1-05038a41c2610263249c79c5f1671ca1.png";